import { useCallback, useState } from "react";
import {
    IMessagePageContent,
    IMessagePart,
    IResponse,
    TResponse,
} from "../../services/interface/data";
import { updateMessage } from "./useData.utils";

const useData = () => {
    const [data, setData] = useState<IResponse>();

    const updateData = useCallback(
        (response: TResponse<IMessagePart | IMessagePageContent>) => {
            const isBodyPart = (
                response: IMessagePart | IMessagePageContent
            ): response is IMessagePart => {
                return (response as IMessagePart).id !== undefined;
            };

            if (isBodyPart(response)) {
                setData(
                    (currentData) =>
                        ({
                            ...currentData,
                            [response.id]: response.value,
                        } as IResponse)
                );
            } else {
                setData((currentData) => updateMessage(currentData, response));
            }
        },
        []
    );

    return {
        data,
        updateData,
    };
};

export default useData;
